'use client';

import { closeUserWayWidget, openUserWayWidget } from '@/utils/userWayWidget';
import { useMemo } from 'react';

/**
 * US 站 UserWay：向业务暴露 open / close。
 * 默认浮标隐藏由根布局 `UserWayDefaultIconInit` 统一调用 `ensureUserWayDefaultIconHidden`。
 */
export function useUserWayWidget() {
  return useMemo(
    () => ({
      openUserWayWidget,
      closeUserWayWidget,
    }),
    [],
  );
}
